export default __webpack_public_path__ + "static/media/opportunity.82281641.svg";